import React, { Component } from 'react'
import ReactDOM from 'react-dom'

import EstimationStore from '../libs/EstimationStore'
import EstimationActions from '../libs/EstimationActions'

class SelectBox extends Component {
  constructor (props) {
    super(props)
    this.state = {
      bindingDataAttribute: this.props.bindingDataAttribute,
      valueAttributeName: this.props.valueAttributeName,
      captionAttributeName: this.props.captionAttributeName,
      options: this.props.options,
      data: EstimationActions.getCurrentEstimation(),
      listener: null
    }
  }
  componentDidMount () {
    this.setState({
      listener: EstimationStore.addListener('change', () => {
        this.setState({
          data: EstimationActions.getCurrentEstimation()
        })
      })
    })
  }
  componentWillUnmount () {
    if (this.state.listener) this.state.listener.remove()
  }
  getDataValue () {
    if (this.props.isList) {
      let listName = this.props.listName
      let index = this.props.index
      return this.state.data[listName][index][this.state.bindingDataAttribute]
    }
    return this.state.data[this.state.bindingDataAttribute]
  }
  changeData () {
    const changedValue = ReactDOM.findDOMNode(this.refs.selectbox).value
    if (this.props.isList) {
      let listName = this.props.listName
      let index = this.props.index
      EstimationActions.updateListInCurrentEstimation(listName, index, this.state.bindingDataAttribute, changedValue)
    } else {
      EstimationActions.updateCurrentEstimation(this.state.bindingDataAttribute, changedValue, this.props.callback)
    }
  }
  render () {
    const options = []
    this.state.options.forEach(option => {
      options.push(
        <option key={option[this.state.valueAttributeName]} value={option[this.state.valueAttributeName]}>{option[this.state.captionAttributeName]}</option>
      )
    })
    return (
      <select ref='selectbox' onChange={this.changeData.bind(this)} defaultValue={this.getDataValue()}>
        {options}
      </select>
    )
  }
}

SelectBox.defaultProps = {isList: false, options: [], valueAttributeName: 'id', captionAttributeName: 'name'}
export default SelectBox



// WEBPACK FOOTER //
// ./src/company_user/components/SelectBox.js